import TableDefinitionModel from './models/TableDefinitionModel';
import apiFetchUserList from '../application/user-management/list/api/UserListingAPI';
import apiFetchImpcDetailsList from '../application/impc-details/api/SearchImpcsAPI';
import apiFetchYearlyThresholds from '../application/yearly-thresholds/api/YearlyThresholdsAPI';
import apiFetchRouteView from '../application/route-management/api/RouteManagementAPI';
import apiFetchImpcStockLevelsListAll from '../application/impc-stock-levels/api/ImpcStockLevelsAllAPI';
import apiFetchImpcStockLevelsListWithAlerts from '../application/impc-stock-levels/api/ImpcStockLevelsWithAlertsAPI';
import apiFetchImpcStockLevelsListWithCentralEntryPoint from '../application/impc-stock-levels/api/ImpcStockLevelsWithCentralEntryPointsAPI';
import apiFetchInternalRepatriationsTransactions from '../application/impc-stock-levels/transactions/internal-repatriations/api/InternalRepatriationsTransactionsAPI';
import apiFetchManualPreadviceTransactions from '../application/impc-stock-levels/transactions/manual-preadvice/api/ManualPreadviceTransactionsAPI';
import apiFetchBalanceModificationTransactions from '../application/impc-stock-levels/transactions/balance-modification/api/BalanceModificationTransactionsAPI';
import apiFetchRepatriationsTransactionsHistory from '../application/impc-stock-levels/transactions/transactions-history/repatriations/api/RepatriationsTransactionsHistoryAPI';
import apiFetchBalanceOnHandTransactionsHistory from '../application/impc-stock-levels/transactions/transactions-history/balance-on-hand/api/BalanceOnHandTransactionsHistoryAPI';
import apiFetchPreAdviceTransactionsHistory from '../application/impc-stock-levels/transactions/transactions-history/pre-advice/api/PreAdviceTransactionsHistoryAPI';
import apiFetchBalanceOnHandCurrentInfo from '../application/impc-stock-levels/impc-characteristics/boh-info/api/BalanceOnHandCurrentInfoAPI';
import apiFetchBalanceOnHandExpectedInfo from '../application/impc-stock-levels/impc-characteristics/boh-info/api/BalanceOnHandExpectedInfoAPI';
import apiFetchBalanceOnHandRouteInfo from '../application/impc-stock-levels/impc-characteristics/boh-info/api/BalanceOnHandRouteInfoAPI';
import apiFetchBalanceOnHandPastInfo from '../application/impc-stock-levels/impc-characteristics/boh-historic/api/BalanceOnHandPastInfoAPI';
import apiFetchPredesTransactions from '../application/impc-stock-levels/transactions/predes/api/PredesTransactionsAPI';
import apiFetchRouteModificationTransactions from '../application/impc-stock-levels/transactions/route-modification/api/RouteModificationTransactionsAPI';
import apiFetchRouteModificationTransactionsHistory from '../application/impc-stock-levels/transactions/transactions-history/route-modification/api/RouteModificationTransactionsHistoryAPI';
import apiFetchPredesTransactionsHistory from '../application/impc-stock-levels/transactions/transactions-history/predes/api/PredesTransactionsHistoryAPI';
import apiFetchBalanceOnHandReportResult from '../application/reporting/balance-on-hand/api/BalanceOnHandReportAPI';
import { apiFetchMemberPoolStorages } from '../application/member-pool-storage/api/MemberPoolStorageAPI';
import apiFetchFluxVolumeOeReport from '../application/reporting/flux-volume-oe/api/FluxVolumeOeReportAPI';
import apiFetchFluxVolumeOperatorReport from '../application/reporting/flux-volume-operator/api/FluxVolumeOperatorReportAPI';
import apiFetchInternalRepatriationReport from '../application/reporting/internal-repatriation/api/InternalRepatriationReportAPI';
import apiFetchCenterInitiatedRepatriationReport from '../application/reporting/center-initiated-repatriation/api/CenterInitiatedRepatriationReportAPI';
import apiFetchTotalPoolBreakdownReport from '../application/reporting/total-pool-breakdown/api/TotalPoolBreakdownReportAPI';
import apiFetchRfidMovementCountReport from '../application/reporting/rfid-movement-count/api/RfidMovementCountReportAPI';
import apiFetchRfidOnRouteReport from '../application/reporting/rfid-on-route/api/RfidOnRouteReportAPI';
import apiFetchTransactionManagementPage from '../application/transaction-management/view-transaction/api/ViewTransactionsPageAPI';
import apiFetchTransactionHistory from '../application/transaction-management/view-transaction-history/api/ViewTransactionHistoryAPI';
import apiFetchRfidOnRouteNonConsolidatedReport from '../application/reporting/rfid-on-route/rfid-on-route-non-consolidated/api/RfidOnRouteNonConsolidatedReportAPI';
import {
  apiFetchEdiRfidAuditRequestExecutions,
  apiFetchEdiRfidAuditRequests,
} from '../application/edi-rfid-audit/api/EdiRfidAuditRequestsApi';
import apiFetchRfidUploadedFilesList from '../application/rfid-file-management/api/RfidUploadedFilesListAPI';
import apiFetchRfidFilesErrorsList from '../application/rfid-file-management/errors/api/RfidFilesErrorsAPI';
import { apiFetchDailyRouteLeadingCountStatusList } from '../application/daily-route-leading-count-status/api/DailyRouteLeadingCountStatusAPI';
import apiFetchDailyRouteLeadingCount from '../application/reporting/daily-route-leading-count/api/DailyRouteLeadingCountAPI';
import { apiFetchEdiRfidAuditRequestExecutionReport } from '../application/edi-rfid-audit/execution/report/api/EdiRfidAuditRequestExecutionReportAPI';
import apiFetchBalanceOnHandThresholds from '../application/impc-stock-levels/impc-characteristics/boh-thresholds/api/BalanceOnHandThresholdsAPI';
import apiFetchRecalculateTasksList from '../application/recalculate-tasks/api/RecalculateTasksAPI';

export default {
  USER_LIST_PAGE: new TableDefinitionModel(
    'USER_LIST_PAGE',
    apiFetchUserList,
  ),
  IMPC_DETAILS_PAGE: new TableDefinitionModel(
    'IMPC_DETAILS_PAGE',
    apiFetchImpcDetailsList,
  ),
  YEARLY_THRESHOLDS_PAGE: new TableDefinitionModel(
    'YEARLY_THRESHOLDS_PAGE',
    apiFetchYearlyThresholds,
  ),
  ROUTE_MANAGEMENT_PAGE: new TableDefinitionModel(
    'ROUTE_MANAGEMENT_PAGE',
    apiFetchRouteView,
  ),
  IMPC_STOCK_LEVELS_ALL_LIST: new TableDefinitionModel(
    'IMPC_STOCK_LEVELS_ALL_LIST',
    apiFetchImpcStockLevelsListAll,
  ),
  IMPC_STOCK_LEVELS_WITH_ALERTS_LIST: new TableDefinitionModel(
    'IMPC_STOCK_LEVELS_WITH_ALERTS_LIST',
    apiFetchImpcStockLevelsListWithAlerts,
  ),
  IMPC_STOCK_LEVELS_WITH_CENTRAL_ENTRY_POINT: new TableDefinitionModel(
    'IMPC_STOCK_LEVELS_WITH_CENTRAL_ENTRY_POINT',
    apiFetchImpcStockLevelsListWithCentralEntryPoint,
  ),
  INTERNAL_REPATRIATIONS_TRANSACTIONS: new TableDefinitionModel(
    'INTERNAL_REPATRIATIONS_TRANSACTIONS',
    apiFetchInternalRepatriationsTransactions,
  ),
  CENTER_INITIATED_REPATRIATIONS: new TableDefinitionModel(
    'CENTER_INITIATED_REPATRIATIONS',
    apiFetchInternalRepatriationsTransactions,
  ),
  MANUAL_PREADVICE_TRANSACTIONS: new TableDefinitionModel(
    'MANUAL_PREADVICE_TRANSACTIONS',
    apiFetchManualPreadviceTransactions,

  ),
  BALANCE_MODIFICATION_TRANSACTIONS: new TableDefinitionModel(
    'BALANCE_MODIFICATION_TRANSACTIONS',
    apiFetchBalanceModificationTransactions,
  ),
  REPATRIATIONS_TRANSACTIONS_HISTORY: new TableDefinitionModel(
    'REPATRIATIONS_TRANSACTIONS_HISTORY',
    apiFetchRepatriationsTransactionsHistory,
  ),
  BALANCE_ON_HAND_TRANSACTIONS_HISTORY: new TableDefinitionModel(
    'BALANCE_ON_HAND_TRANSACTIONS_HISTORY',
    apiFetchBalanceOnHandTransactionsHistory,
  ),
  PREADVICE_TRANSACTIONS_HISTORY: new TableDefinitionModel(
    'PREADVICE_TRANSACTIONS_HISTORY',
    apiFetchPreAdviceTransactionsHistory,
  ),
  VIEW_BOH_CURRENT_INFO: new TableDefinitionModel(
    'VIEW_BOH_CURRENT_INFO',
    apiFetchBalanceOnHandCurrentInfo,
  ),
  BALANCE_ON_HAND_THRESHOLDS_PAGE: new TableDefinitionModel(
    'BALANCE_ON_HAND_THRESHOLDS_PAGE',
    apiFetchBalanceOnHandThresholds,
  ),
  VIEW_BOH_EXPECTED_INFO: new TableDefinitionModel(
    'VIEW_BOH_EXPECTED_INFO',
    apiFetchBalanceOnHandExpectedInfo,
  ),
  VIEW_BOH_ROUTE_INFO: new TableDefinitionModel(
    'VIEW_BOH_ROUTE_INFO',
    apiFetchBalanceOnHandRouteInfo,
  ),
  VIEW_BOH_PAST_INFO: new TableDefinitionModel(
    'VIEW_BOH_PAST_INFO',
    apiFetchBalanceOnHandPastInfo,
  ),
  PREDES_TRANSACTIONS: new TableDefinitionModel(
    'PREDES_TRANSACTIONS',
    apiFetchPredesTransactions,
  ),
  ROUTE_MODIFICATION_TRANSACTIONS: new TableDefinitionModel(
    'ROUTE_MODIFICATION_TRANSACTIONS',
    apiFetchRouteModificationTransactions,
  ),
  ROUTE_MODIFICATION_TRANSACTIONS_HISTORY: new TableDefinitionModel(
    'ROUTE_MODIFICATION_TRANSACTIONS_HISTORY',
    apiFetchRouteModificationTransactionsHistory,
  ),
  PREDES_TRANSACTIONS_HISTORY: new TableDefinitionModel(
    'PREDES_TRANSACTIONS_HISTORY',
    apiFetchPredesTransactionsHistory,
  ),
  REPORTING_BALANCE_ON_HAND_PAGE: new TableDefinitionModel(
    'REPORTING_BALANCE_ON_HAND_PAGE',
    apiFetchBalanceOnHandReportResult,
  ),
  MEMBER_POOL_STORAGE_PAGE: new TableDefinitionModel(
    'MEMBER_POOL_STORAGE_PAGE',
    apiFetchMemberPoolStorages,
  ),
  REPORTING_FLUX_VOLUME_OE: new TableDefinitionModel(
    'REPORTING_FLUX_VOLUME_OE',
    apiFetchFluxVolumeOeReport,
  ),
  REPORTING_FLUX_VOLUME_OPERATOR: new TableDefinitionModel(
    'REPORTING_FLUX_VOLUME_OPERATOR',
    apiFetchFluxVolumeOperatorReport,
  ),
  REPORTING_INTERNAL_REPATRIATIONS: new TableDefinitionModel(
    'REPORTING_INTERNAL_REPATRIATIONS',
    apiFetchInternalRepatriationReport,
  ),
  REPORTING_CENTER_INITIATED_REPATRIATIONS: new TableDefinitionModel(
    'REPORTING_CENTER_INITIATED_REPATRIATIONS',
    apiFetchCenterInitiatedRepatriationReport,
  ),
  REPORTING_TOTAL_POOL_BREAKDOWN: new TableDefinitionModel(
    'REPORTING_TOTAL_POOL_BREAKDOWN',
    apiFetchTotalPoolBreakdownReport,
  ),
  REPORTING_RFID_MOVEMENT_COUNT: new TableDefinitionModel(
    'REPORTING_RFID_MOVEMENT_COUNT',
    apiFetchRfidMovementCountReport,
  ),
  REPORTING_RFID_ON_ROUTE: new TableDefinitionModel(
    'REPORTING_RFID_ON_ROUTE',
    apiFetchRfidOnRouteReport,
  ),
  TRANSACTION_MANAGEMENT: new TableDefinitionModel(
    'TRANSACTION_MANAGEMENT',
    apiFetchTransactionManagementPage,
  ),
  TRANSACTION_HISTORY: new TableDefinitionModel(
    'TRANSACTION_HISTORY',
    apiFetchTransactionHistory,
  ),
  REPORTING_RFID_ON_ROUTE_NON_CONSOLIDATED: new TableDefinitionModel(
    'REPORTING_RFID_ON_ROUTE_NON_CONSOLIDATED',
    apiFetchRfidOnRouteNonConsolidatedReport,
  ),
  EDI_RFID_AUDIT_REQUESTS_LIST_PAGE: new TableDefinitionModel(
    'EDI_RFID_AUDIT_REQUESTS_LIST_PAGE',
    apiFetchEdiRfidAuditRequests,
  ),
  EDI_RFID_AUDIT_REQUEST_EXECUTIONS: new TableDefinitionModel(
    'EDI_RFID_AUDIT_REQUEST_EXECUTIONS',
    apiFetchEdiRfidAuditRequestExecutions,
  ),
  RFID_UPLOADED_FILES_LIST: new TableDefinitionModel(
    'RFID_UPLOADED_FILES_LIST',
    apiFetchRfidUploadedFilesList,
  ),
  RFID_FILES_ERRORS_LIST: new TableDefinitionModel(
    'RFID_FILES_ERRORS_LIST',
    apiFetchRfidFilesErrorsList,
  ),
  DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE: new TableDefinitionModel(
    'DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE',
    apiFetchDailyRouteLeadingCountStatusList,
  ),
  DAILY_ROUTE_LEADING_COUNT_SUMMARY: new TableDefinitionModel(
    'DAILY_ROUTE_LEADING_COUNT_SUMMARY',
    apiFetchDailyRouteLeadingCount,
  ),
  EDI_RFID_AUDIT_REQUEST_EXECUTION_REPORT: new TableDefinitionModel(
    'EDI_RFID_AUDIT_REQUEST_EXECUTION_REPORT',
    apiFetchEdiRfidAuditRequestExecutionReport,
  ),
  RECALCULATE_TASKS_LIST: new TableDefinitionModel(
    'RECALCULATE_TASKS_LIST',
    apiFetchRecalculateTasksList,
  ),
};
